/**
 * Apply custom variant colors from data attributes to CSS variables
 * This avoids inline style conflicts that cause sizing issues
 */
(function() {
  'use strict';
  
  function applyVariantColors() {
    const buttons = document.querySelectorAll('.radio__button--custom-colors');
    
    buttons.forEach(button => {
      const bg = button.getAttribute('data-bg');
      const text = button.getAttribute('data-text');
      const border = button.getAttribute('data-border');
      const hoverBg = button.getAttribute('data-hover-bg');
      const hoverText = button.getAttribute('data-hover-text');
      
      if (bg) button.style.setProperty('--custom-bg', bg);
      if (text) button.style.setProperty('--custom-text', text);
      if (border) button.style.setProperty('--custom-border', border);
      if (hoverBg) button.style.setProperty('--custom-hover-bg', hoverBg);
      if (hoverText) button.style.setProperty('--custom-hover-text', hoverText);
    });
  }
  
  // Apply on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyVariantColors);
  } else {
    applyVariantColors();
  }
  
  // Reapply when product changes (for quick view, AJAX, etc.)
  if (typeof window.theme !== 'undefined') {
    document.addEventListener('product:changed', applyVariantColors);
  }
})();

